import { CaseStudyHome } from '../../components/customers/home/Home';

export default function CaseStudyIndexPage() {
  return <CaseStudyHome />;
}
